import AdminApi from '../services/api';
import swal from 'sweetalert2';

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'schedule'],

    data() {
        return {
            title: '',
            isLoading: false,
            selectedSchedule: null,
            tabIndex: 0,
            selectedCourier: '',
            salary: 0.0,
            cost: 0.0,
            expense: 0.0,
            hasError: '',
            workingHours : 0,
            greenVoucher : 0,
            blueVoucher : 0,
            whiteVoucher : 0,
            visibleCupons: false,
            visibleAddHours: false
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedSchedule = this.schedule;
                this.tabIndex = this.selectedSchedule.vehicle.registrationPlate === "*" ? 1 : 0;
                this.selectedCourier = this.selectedSchedule.courier.username;
                this.selectedScheduleId = this.selectedSchedule.id;
                this.detectVouchers(this.selectedSchedule);
                this.visibleCupons = this.greenVoucher > 0 || this.blueVoucher > 0 || this.whiteVoucher > 0;
            }
        },
        salary: function(val, oldVal) {
            this.hasError = '';
        },
        cost: function(val, oldVal) {
            this.hasError = '';
        }
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeCompleteDay')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successCompleteDay')
        },

        completeDayForUser: completeDayForUser,
        showCupons: showCupons,
        showHours: showHours,
        detectVouchers: detectVouchers,
        generateVoucher: generateVoucher,
        minusVoucher: minusVoucher,
        plusVoucher: plusVoucher,
        minusHour: minusHour,
        plusHour: plusHour,
        getModuleStyle: getModuleStyle,
        setTab: setTab,
        reset: reset,
    }
}

function detectVouchers(schedule){
    var voucher = schedule.voucher;
    if(voucher == null || voucher.length === 0) return;
    var tempVouchers = voucher.split(";");
    tempVouchers.forEach(e => {
        var tempVoucher =  e.split("-");
        if(tempVoucher[0] === 'VOUCHER_GREEN'){
            this.greenVoucher = tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);
        }
        if(tempVoucher[0] === 'VOUCHER_BLUE'){
            this.blueVoucher =  tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);
        }
        if(tempVoucher[0] === 'VOUCHER_WHITE'){
            this.whiteVoucher = tempVoucher.length <= 1 ? 1 : parseInt(tempVoucher[1]);
        }
    });
}

function completeDayForUser() {
    if(this.tabIndex === 0){
        if(this.salary.length === 0 ||
            this.salary === 0.0 ) {
            this.hasError = "Molimo popunite sva dnevnicu";
            return;
        }
    }else{
        if(this.salary.length === 0 ||
            this.salary === 0.0) {
            this.hasError = "Molimo popunite sva polja";
            return;
        }
    }

    let _self = this;
    let hoursInMillisecond = _self.selectedSchedule.startTime != null ? (_self.selectedSchedule.startTime + (1000 * 60 * 60 * _self.workingHours)) : 0;
    const newModel = {
        salary: _self.tabIndex === 0 ? parseFloat(_self.salary) : ( _self.selectedSchedule.ordersPriceAmount - parseFloat(_self.salary) ),
        cost: parseFloat(_self.cost),
        expense: parseFloat(_self.expense),
        voucher: this.generateVoucher(),
        completionTime: _self.workingHours > 0 && _self.selectedSchedule.startTime != null ? hoursInMillisecond : 0
    };

    _self.isLoading = true;
    AdminApiService.completeSchedule(_self.selectedScheduleId, newModel)
        .then((response) => {
            _self.reset();
            _self.isLoading = false;
            _self.successUpdate();
        })
        .catch((error) => {
            _self.reset();
            _self.isLoading = false;
            _self.hasError = "Greška prilikom dodavanja."
        })

}

function generateVoucher() {
    var returnValue = "";
    if(this.greenVoucher > 0) returnValue += "VOUCHER_GREEN-"+this.greenVoucher+";";
    if(this.blueVoucher > 0) returnValue += "VOUCHER_BLUE-"+this.blueVoucher+";";
    if(this.whiteVoucher > 0) returnValue += "VOUCHER_WHITE-"+this.whiteVoucher+";";
    if(returnValue.isEmpty){
        return null;
    }else{
        return returnValue;
    }
}

function reset() {
    this.salary = '';
    this.cost = '';
    this.blueVoucher = 0;
    this.greenVoucher = 0;
    this.whiteVoucher = 0;
    this.workingHours = 0;

    this.visibleCupons = false;
    this.visibleAddHours = false;
}

function getModuleStyle(index) {
    if(index === this.tabIndex){
        return "background: #70b1e7; color: white;"
    }else {
        return "background: white; color: black; border: white;"
    }
}

function setTab(tab) {
    this.tabIndex = tab;
}

function showCupons() {
    this.visibleCupons = !this.visibleCupons;
}
function showHours() {
    this.visibleAddHours = !this.visibleAddHours;
}

function plusVoucher(voucher, value) {
    switch (voucher) {
        case 'VOUCHER_BLUE': {
            this.blueVoucher = this.blueVoucher + value;
            break;
        }
        case 'VOUCHER_GREEN': {
            this.greenVoucher = this.greenVoucher + value;
            break;
        }
        case 'VOUCHER_WHITE': {
            this.whiteVoucher = this.whiteVoucher + value;
            break;
        }
    }
}

function minusVoucher(voucher, value) {
    switch (voucher) {
        case 'VOUCHER_BLUE': {
            if(this.blueVoucher > 0){
                this.blueVoucher = this.blueVoucher - value;
            }
            break;
        }
        case 'VOUCHER_GREEN': {
            if(this.greenVoucher > 0){
                this.greenVoucher = this.greenVoucher - value;
            }
            break;
        }
        case 'VOUCHER_WHITE': {
            if(this.whiteVoucher > 0){
                this.whiteVoucher = this.whiteVoucher - value;
            }
            break;
        }
    }
}

function minusHour(){
    if(this.workingHours > 0){
        this.workingHours--;
    }
}

function plusHour(){
    this.workingHours++;
}


// WEBPACK FOOTER //
// ./src/modals/CompleteDayModal.js